<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12 text-center">
      <div class="container">
        <div class="text-center" style="margin-top:5%">
          <h2>YOU HAVE ALREADY FILED A CLAIM</h2>
          <br />
          <p>If you need to complete an additional claim, please <a href="javascript:void(0)" (click)="continueToClaimForm()" style="color:#006cDb; text-decoration:underline;">click here</a>.</p>
        </div>

        <div class="row mt-5">
          <div class="col-md-12 text-center">
            <a href="https://www.goodrxprivacysettlement.com/" class="btn btn-primary">Exit to Return to the Settlement Website</a>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
  <br /><br />
</div>
